import * as T from "../../utilities/frontendTypes";
import { apiGet, apiPut } from "../apiClient";

export async function getCoachPreMeetingDetailsAsync(): Promise<{success: boolean, preMeetingFoundersArray: {companyName: string, id: string, date: Date}[]}> {
  return apiGet<{success: boolean, preMeetingFoundersArray: {companyName: string, id: string, date: Date}[]}>("/api/admins/coach-premeeting-founders");
}

export async function getCoachInProgressDetailsAsync(): Promise<{success: boolean, inProgressFoundersArray: {companyName: string, date: Date, id: string}[]}> {
  return apiGet<{success: boolean, inProgressFoundersArray: {companyName: string, date: Date, id: string}[]}>("/api/admins/coach-in-progress-founders");
}

export async function getCoachRecommendationFounderHeaders(): Promise<{success: boolean, coachRecommendationsArray: {companyName: string, recommendation: string, id: T.UserId}[]}> {
  return apiGet<{success: boolean, coachRecommendationsArray: {companyName: string, recommendation: string, id: T.UserId}[]}>("/api/admins/coach-recommendations");
}

// time/notes optional: the admin outcome form records neither — an omitted
// time must not zero out minutes the coach already logged (server skips the
// $set when time is absent).
export async function growthCoachOutcomeUpdate(appId: string, coachStatus: string, time?: number, notes?: string, rejectionReason?: string): Promise<T.HTTPResponse> {
  return apiPut<T.HTTPResponse>("/api/admins/set-growth-coach-outcome", { appId, coachStatus, notes, time, rejectionReason });
}

export interface CoachDetails {
  id: string;
  /** The founder's active GC-stage application — what outcome updates target. */
  applicationId: string | null;
  date: Date;
  companyName: string;
  status?: string;
}

export async function getCoachPreMeetingDetails(userId: T.UserId): Promise<{success: boolean, coachDetails: CoachDetails}> {
  return apiGet<{success: boolean, coachDetails: CoachDetails}>(`/api/admins/coach-premeeting-founders/${userId}`);
}

export async function getCoachProgressDetails(userId: T.UserId): Promise<{success: boolean, coachDetails: CoachDetails}> {
  return apiGet<{success: boolean, coachDetails: CoachDetails}>(`/api/admins/coach-in-progress-founders/${userId}`);
}

export async function growthCoachByapplication(applicationId: string): Promise<T.HTTPResponse> {
  return apiPut<T.HTTPResponse>("/api/admins/update-growth-coach-by-application", { applicationId });
}

export async function getGrowthCoachDashboard(): Promise<{success: boolean, foundersArray: {id: string, industry: string, companyName: string, date: Date, status: string, gcName?: string, daysInReview: number}[], name: string}> {
  return apiGet<{success: boolean, foundersArray: {id: string, industry: string, companyName: string, date: Date, status: string, gcName?: string, daysInReview: number}[], name: string}>("/api/admins/get-growth-coach-dashboard");
}

export async function gcAssign(appId: string): Promise<T.HTTPResponse> {
  return apiPut<T.HTTPResponse>("/api/admins/assign-growth-coach", { appId });
}

export async function getGrowthCoachInProg(): Promise<{success: boolean, foundersArray: {id: string, contact: string, companyName: string, date: Date, actionItem: string}[], name: string}> {
  return apiGet<{success: boolean, foundersArray: {id: string, contact: string, companyName: string, date: Date, actionItem: string}[], name: string}>("/api/admins/get-growth-coach-in-prog");
}

export async function getGcMemberDetails(id: T.UserId): Promise<T.MemberDetailsResponse> {
  return apiGet<T.MemberDetailsResponse>(`/api/admins/member-details/${id}`);
}

export async function getGrowthCoachTimeReport(): Promise<{success: boolean, foundersArray: {id: string, companyName: string, date: Date, minutesWorked: number}[], name: string}> {
  return apiGet<{success: boolean, foundersArray: {id: string, companyName: string, date: Date, minutesWorked: number}[], name: string}>("/api/admins/get-growth-coach-time-report");
}

export type GrowthCoachAssessmentHeader = {
  id: string,
  companyName: string,
  contactPerson: string,
  status: string,
  gcName?: string,
  inviteDate?: Date,
  assessmentSubmitDate?: Date,
  timeSpentMinutes?: number,
  stageChangedAt: Date
}

export async function getGrowthCoachAllAssessments(): Promise<{success: boolean, foundersArray: GrowthCoachAssessmentHeader[], name: string}> {
  return apiGet<{success: boolean, foundersArray: GrowthCoachAssessmentHeader[], name: string}>("/api/admins/get-growth-coach-all-assessments");
}
